<script>
    import { onDestroy, onMount, createEventDispatcher } from "svelte";
    import Constantes from "../Classes/Constantes";
    import LoadingTela from "./LoadingTela.svelte";
    import Conexoes from "../Classes/Conexoes";
    import Loading from "./Loading.svelte";
    
    const dispatch = new createEventDispatcher();
    let cardForm;
    let carregando = false;
    let alertMessage = "";
    let alertType = "";
    export let cod_inscricao_encurtado = "";
    export let valor;
    export let showModal = false;
    let recusado = false;
    let tentativa = 0;
    let publicKey;
    let conexao = new Conexoes();
    let carregando2=false;
    onMount(async () => {
        // Adiciona o script de segurança do Mercado Pago para obter o Device ID
        const script = document.createElement("script");
        script.src = "https://www.mercadopago.com/v2/security.js";
        script.setAttribute("view", "checkout");
        document.body.appendChild(script);
        await PegaPublicKey();
    });

    async function PegaPublicKey() {
        let retorno = await conexao.conecta(Constantes.api_consultar_padrao, {
            query_code: "pega_publicKey",
            cod_inscricao_encurtado: cod_inscricao_encurtado,
        });
        publicKey = retorno[0].publicKey;
        InstaciaForm(publicKey);
    }

    function InstaciaForm(publicKey) {
        // Inicializa o CardForm do Mercado Pago

        let mp = new MercadoPago(publicKey);
        cardForm = mp.cardForm({
            amount: valor,
            iframe: true,
            form: {
                id: "form-checkout",
                cardNumber: {
                    id: "form-checkout__cardNumber",
                    placeholder: "Número do cartão",
                },
                expirationDate: {
                    id: "form-checkout__expirationDate",
                    placeholder: "MM/YY",
                },
                securityCode: {
                    id: "form-checkout__securityCode",
                    placeholder: "Código de segurança",
                },
                cardholderName: {
                    id: "form-checkout__cardholderName",
                    placeholder: "Titular do cartão",
                },
                issuer: {
                    id: "form-checkout__issuer",
                    placeholder: "Banco emissor",
                },
                installments: {
                    id: "form-checkout__installments",
                    placeholder: "Parcelas",
                },
                identificationType: {
                    id: "form-checkout__identificationType",
                    placeholder: "Tipo de documento",
                },
                identificationNumber: {
                    id: "form-checkout__identificationNumber",
                    placeholder: "Número do documento",
                },
            },
            callbacks: {
                onFormMounted: (error) => {
                    if (error)
                        return console.warn(
                            "Form Mounted handling error: ",
                            error,
                        );
                    console.log("Form mounted");
                },
                onSubmit: (event) => {
                    event.preventDefault();
                    console.log("clicando");

                    const {
                        paymentMethodId: payment_method_id,
                        issuerId: issuer_id,
                        cardholderEmail: email,
                        amount,
                        token,
                        installments,
                         identificationNumber,
            identificationType,
                    } = cardForm.getCardFormData();

                    const device_id = window.MP_DEVICE_SESSION_ID || "";

                    carregando = true;
                    fetch(Constantes.url_pagar_cartao, {
                        method: "POST",
                        headers: {
                            "Content-Type": "application/json",
                        },
                        body: JSON.stringify({
                            token,
                            issuer_id,
                            payment_method_id,
                            transaction_amount: Number(amount),
                            installments: Number(installments),
                            description: "Descrição do produto",
                            cod_inscricao_encurtado: cod_inscricao_encurtado,
                            device_id: device_id, // Adiciona o Device ID aqui
                            type: identificationType,
                            number: identificationNumber,
                        }),
                    })
                        .then((response) =>
                            response.json().then((data) => ({
                                status: response.status,
                                body: data,
                            })),
                        )
                        .then(({ status, body }) => {
                            carregando = false;
                            if (
                                body.status === "approved" ||
                                body.status === "aprovado"
                            ) {
                                alertType = "alert-success";
                                alertMessage =
                                    "Pagamento efetuado com sucesso.";
                                carregando = false;
                                carregando2=false;
                                dispatch("pago");
                            } else if (
                                body.status === "pending" ||
                                body.status === "in_process"
                            ) {
                                alertType = "alert-warning";
                                alertMessage = "Aguardando pagamento.";
                                carregando2=true;
                            } else {
                                alertType = "alert-danger";
                                alertMessage = "Pagamento recusado.";
                                carregando = false;
                                recusado = true;
                                carregando2=false;


                            }
                            console.log("Success:", body);

                            tentativa += 1;
                        })
                        .catch((error) => {
                            carregando = false;
                            alertType = "alert-danger";
                            alertMessage = "Erro ao processar o pagamento.";
                            console.error("Error:", error);
                            carregando = false;
                            recusado = true;
                        });
                },
                onFetching: (resource) => {
                    console.log("Fetching resource: ", resource);

                    // Animate progress bar
                    //const progressBar = document.querySelector(".progress-bar");
                    // progressBar.removeAttribute("value");

                    return () => {
                        //progressBar.setAttribute("value", "0");
                    };
                },
            },
        });
    }

    onDestroy(() => {
         Finaliza();
    });

    function Finaliza(){
cardForm = null;
        showModal = false;
        window.location.reload();
    }
</script>

<LoadingTela isLoading={carregando} />
{#if showModal}
    <div class="modal">
        <div class="modal-content">
            <button class="close" on:click={() => (showModal = false)}
                >&times;</button
            >
            <h5>Pagamento com Cartão de Crédito</h5>

            <form id={"form-checkout"} class="form-checkout">
                <div id="form-checkout__cardNumber" class="container"></div>
                <div id="form-checkout__expirationDate" class="container"></div>
                <div id="form-checkout__securityCode" class="container"></div>
                <input
                    type="text"
                    id="form-checkout__cardholderName"
                    style="height: 50px; display: inline-block; border: 1px solid rgb(118, 118, 118); border-radius: 8px; padding: 10px 10px;"
                />
                <select
                    id="form-checkout__issuer"
                    style="height: 50px; display: inline-block; border: 1px solid rgb(118, 118, 118); border-radius: 8px; padding: 10px 10px;"
                ></select>
                <select
                    id="form-checkout__installments"
                    style="height: 50px; display: inline-block; border: 1px solid rgb(118, 118, 118); border-radius: 8px; padding: 10px 10px;"
                ></select>

                  <select id="form-checkout__identificationType"   style="height: 50px; display: inline-block; border: 1px solid rgb(118, 118, 118); border-radius: 8px; padding: 10px 10px;"
           ></select>
                <input type="text" id="form-checkout__identificationNumber"   style="height: 50px; display: inline-block; border: 1px solid rgb(118, 118, 118); border-radius: 8px; padding: 10px 10px;"
             />


                {#if !recusado}
                    <button
                        type="submit"
                        id="form-checkout__submit"
                        class="botaoEstiloMUI">Pagar</button
                    >
                {:else}
                    <button
                        on:clickon:click={() => Finaliza()}
                        id="form-checkout__submit"
                        class="botaoEstiloMUI">Tentar novamente</button
                    >
                {/if}
                <!--  <progress value="0" class="progress-bar">Carregando...</progress
                >-->
            </form>

            {#if alertMessage}
            <Loading carregando={carregando2} />
                <div class="alert {alertType} mt-3" role="alert">
                    {alertMessage}
                </div>
            {/if}
        </div>
    </div>
{/if}

<style>
    .modal {
        display: flex;
        align-items: center;
        justify-content: center;
        position: fixed;
        z-index: 997;
        left: 0;
        top: 0;
        width: 100%;
        height: 100%;
        overflow: auto;
        background-color: rgba(0, 0, 0, 0.4);
    }

    .modal-content {
        background-color: #fefefe;
        padding: 20px;
        border: 1px solid #888;
        width: 500px; /* Largura fixa de 400px */
        max-width: 80%; /* Limita a largura máxima a 80% da largura da tela */
        height: 650px; /* Altura fixa de 500px */
        max-height: 80%; /* Limita a altura máxima a 80% da altura da tela */
        border-radius: 10px;
        overflow-y: auto;

        display: flex; /* Torna o conteúdo um flex container */
        flex-direction: column; /* Alinha os itens verticalmente */
        justify-content: center; /* Centraliza os itens horizontalmente */
    }

    /* Media query para ajustar as dimensões em dispositivos móveis */
    @media (max-width: 768px) {
        .modal-content {
            width: 90%; /* Largura ajustada para 90% da largura da tela */
            height: auto; /* Altura ajustada automaticamente conforme conteúdo */
            max-height: 90%; /* Limita a altura máxima a 90% da altura da tela */
        }
    }

    .modal-body {
        max-height: calc(100% - 40px); /* Ajuste para o padding */
        overflow-y: auto;
    }

    .close {
        color: #aaa;
        position: absolute;
        top: 5px;
        right: 5px;
        font-size: 20px;
        font-weight: bold;
        background-color: transparent;
        border: none;
        cursor: pointer;
    }

    .close:hover {
        color: #000;
    }
    .form-checkout {
        display: flex;
        flex-direction: column;
        max-width: 600px;
    }

    .container {
        height: 50px;
        display: inline-block;
        border: 1px solid rgb(118, 118, 118);
        border-radius: 8px;
        padding: 10px 10px;
    }

    .botaoEstiloMUI {
        display: inline-block;
        background-color: #1a89e4; /* Cor de fundo do botão */
        color: white;
        padding: 10px 20px;
        text-align: center;
        text-decoration: none;
        border-radius: 8px; /* Borda arredondada */
        cursor: pointer;
        box-shadow:
            0px 3px 1px -2px rgba(0, 0, 0, 0.2),
            0px 2px 2px 0px rgba(0, 0, 0, 0.14),
            0px 1px 5px 0px rgba(0, 0, 0, 0.12); /* Sombra */
        transition: background-color 0.3s ease; /* Transição suave da cor de fundo */
    }

    .botaoEstiloMUI:hover {
        background-color: #0d47a1; /* Cor de fundo ao passar o mouse */
    }
</style>
